/**
 * 配列関連ユーティリティ
 */
export default {
  /**
   * 画像データの最初のMIME情報を削除
   * @param base64
   */
  removeMime (base64) {
    return base64.replace(/data:image\/[a-zA-Z0-9]+;base64,/g, '')
  }
}
